import WebServiceRequest from "../../../Api/WebServiceRequest";

class VirtualCategoriesCreate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VirtualCategory/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default VirtualCategoriesCreate;
